module.exports = __webpack_public_path__ + "img/partner-nhr.a0a5c631.png";